/**
 * React Query 查询键集中管理（避免同一资源出现多个键导致缓存失效不一致）。
 */
export const qk = {
  me: () => ['me'] as const,
  myTeams: () => ['me', 'teams'] as const,
  myTasks: () => ['me', 'tasks'] as const,
  candidates: (eventCode?: string) => ['candidates', eventCode && eventCode.length > 0 ? eventCode : 'all'] as const,
  /** 候选人列表的**前缀键**：载入/清除演示数据后用它一次失效所有筛选下的列表 */
  candidatesRoot: () => ['candidates'] as const,
  team: (teamId: string) => ['team', teamId] as const,
  projectTasks: (projectId: string) => ['project', projectId, 'tasks'] as const,
  event: (code: string) => ['event', code] as const,
  /** 赛事列表（Events 页）；过滤条件进入键，保证不同 tab 各自缓存 */
  events: (filter?: { scope?: 'common' | 'exclusive'; school?: string }) =>
    ['events', filter?.scope ?? '', filter?.school ?? ''] as const,
  /** 赛事时间轴（EventDetail 页：里程碑 + 动态） */
  eventTimeline: (code: string) => ['event', code, 'timeline'] as const,
  /** 演示数据条数（Layout 角标 + 设置页共用） */
  demoStatus: () => ['demo', 'status'] as const,
  /** 正在招募的队伍卡片（T72；招募展示已由组队大厅承载） */
  recruiting: (eventCode?: string) => ['recruiting', eventCode && eventCode.length > 0 ? eventCode : 'all'] as const,
  /** 指导老师列表（T77） */
  advisors: () => ['advisors'] as const,
  /** 队伍技能缺口（扩展①） */
  gap: (teamId: string) => ['team', teamId, 'gap'] as const,
  /** 赛事需求集（扩展①） */
  eventRequirements: (code: string) => ['event', code, 'requirements'] as const,
  /** 组队大厅卡片（扩展②） */
  hall: (eventCode?: string) => ['hall', eventCode && eventCode.length > 0 ? eventCode : 'all'] as const,
  /** 队伍文件中心（扩展③） */
  teamFiles: (teamId: string) => ['team', teamId, 'files'] as const,
  /** 团队决策日志（扩展③） */
  teamDecisions: (teamId: string) => ['team', teamId, 'decisions'] as const,
  /** 项目备赛进度（扩展③） */
  projectProgress: (projectId: string) => ['project', projectId, 'progress'] as const,
  /** 导师反馈列表（扩展⑥） */
  teamFeedback: (teamId: string) => ['team', teamId, 'feedback'] as const,
  /** 项目孵化器方向室（扩展⑦） */
  teamIdeas: (teamId: string) => ['team', teamId, 'ideas'] as const,
  // ---- 队内沟通（聊天/好友）----
  /** 会话列表（含未读） */
  conversations: () => ['chat', 'conversations'] as const,
  /** 未读总数（导航角标轻量轮询） */
  chatUnread: () => ['chat', 'unread'] as const,
  /** 某会话的消息（轮询增量） */
  chatMessages: (conversationId: string) => ['chat', 'messages', conversationId] as const,
  /** 好友/申请列表 */
  friends: () => ['chat', 'friends'] as const,
  // ---- 管理后台（仅 admin 角色）----
  /** 平台概览 */
  adminStats: () => ['admin', 'stats'] as const,
  /** 用户列表（前缀键：改角色/禁用后一次失效所有筛选） */
  adminUsersRoot: () => ['admin', 'users'] as const,
  adminUsers: (query: { keyword?: string; role?: string; page?: number; pageSize?: number }) =>
    ['admin', 'users', query.keyword ?? '', query.role ?? '', query.page ?? 0, query.pageSize ?? 20] as const,
  /** 审计日志 */
  adminAuditRoot: () => ['admin', 'audit'] as const,
  adminAudit: (query: { action?: string; userId?: string; page?: number; pageSize?: number }) =>
    ['admin', 'audit', query.action ?? '', query.userId ?? '', query.page ?? 0, query.pageSize ?? 20] as const,
};